import { render, staticRenderFns } from "./ShiftStoreOld.vue?vue&type=template&id=4aecaf3c&"
import script from "./ShiftStoreOld.vue?vue&type=script&lang=js&"
export * from "./ShiftStoreOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports